import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Logger } from '@app/core/utilities/logger.service';
import { ToastrService } from 'ngx-toastr';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable()
export class ErrorHandlerPermissionsInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(error => this.errorHandler(error)));
  }

  /**
   * Maneja de forma global todos los errores por permisos en las peticiones http.
   *
   * @private
   * @param {HttpErrorResponse} err
   * @returns {Observable<HttpErrorResponse>}
   * @memberof ErrorHandlerInterceptor
   */
  private errorHandler(err: HttpErrorResponse): Observable<HttpEvent<any>> {
    if (err.error instanceof Error) {
      if (!environment.production) {
        log.error('An error occurred:', err.error.message);
      }
      // No hay internet
      if (!navigator.onLine) {
        this.toastr.error(
          'Error en la red',
          'Parece que no estás conectado a internet, por favor verifica tu conexión.'
        );
      } else {
        if (err.status === 401 || err.status === 403) {
          // Se produjo el error por falta de permisos
          this.toastr.warning('Usted no posee los permisos necesarios para realizar esta acción.', 'Permiso denegado');
        }
      }
    } else {
      if (err.status === 401 || err.status === 403) {
        // Se produjo el error por falta de permisos
        this.toastr.warning('Usted no posee los permisos necesarios para realizar esta acción.', 'Permiso denegado');
      }
    }
    throw err;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/http/error-handler-permissions.interceptor.ts